import React from 'react'
// utils
import { cn } from '@utils/cn'

// types
import type { children, className, divider } from './types'

export interface DialogBodyProps extends React.ComponentProps<'div'> {
  divider?: divider
  className?: className
  children: children
}

export const DialogBody = React.forwardRef<HTMLDivElement, DialogBodyProps>(({ divider, className, children, ...rest }, ref) => {
  // 3. set styles
  const baseClasses = 'p-4'
  const dividerClasses = divider ? 'border-t border-blue-gray-100' : ''
  const dialogBodyClasses = cn(baseClasses, dividerClasses, className)

  // 4. return
  return (
    <div {...rest} ref={ref} className={dialogBodyClasses}>
      {children}
    </div>
  )
})

DialogBody.displayName = 'DialogBody'

export default DialogBody

